import moment from 'moment'

const ConversationIcon = () => (
	<svg
		className="h-6 w-6 text-gray-400"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		style={{ opacity: 0.7 }}
	>
		<path
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M7 8h7m-7 4h4m2 8 4-4h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4v4z"
		/>
	</svg>
)

export default function CommunicationHistory({ communications = [] }) {
	const hasData = Array.isArray(communications) && communications.length > 0

	return (
		<div className="px-6 py-8 h-full">
			<h3 className="text-lg font-semibold text-gray-900 mb-6">Communication History</h3>

			<div className="max-h-96 overflow-y-auto border-t border-gray-200">
				{hasData ? (
					communications.map((c, i) => (
						<div
							key={c._id || `${c.added}-${i}`}
							className="flex items-start gap-3 py-4 border-b border-gray-200 last:border-b-0">
							<div className="flex-shrink-0 text-gray-400">
								<ConversationIcon />
							</div>
							<div className="min-w-0 flex-1">
								<p className="text-sm font-semibold text-gray-900">
									{c.added ? moment(c.added).format('YYYY-MM-DD HH:mm') : 'Date unavailable'} by {c.userName || 'Unknown'}
								</p>
								<p className="mt-1 text-sm leading-relaxed text-gray-700 whitespace-pre-wrap">{c.note || '—'}</p>
							</div>
						</div>
					))
				) : (
					<div className="text-center py-8 text-gray-500 text-sm">No communication history.</div>
				)}
			</div>
		</div>
	)
}
